import React from 'react'
import { func } from 'prop-types'
import { IconButton, styled, css } from '@mui/material'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

const StyledButton = styled(IconButton)(
  ({ theme }) => css`
    position: absolute;
    top: 5px;
    right: 5px;
    borderradius: 50%;
    padding: 15px;
    outline: none;

    &:hover: {
      backgroundcolor: ${theme.palette.secondary.light} !important;
    }

    .close: {
      width: 22px;
      height: 22px;
    }
  `,
)

const CloseCartModal = ({ closeModal }) => {
  const handleOnclickLocally = e => {
    e.stopPropagation()
    closeModal(e)
  }

  return (
    <StyledButton type="button" tabIndex="0" value="Close" aria-label="Close" onClick={handleOnclickLocally}>
      <CloseOutlinedIcon />
    </StyledButton>
  )
}

CloseCartModal.propTypes = {
  closeModal: func,
}

export default CloseCartModal
